/* eslint-disable array-element-newline */
/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable  react/jsx-no-bind, max-len, no-underscore-dangle */
import React, {useState} from "react";
import LoadingSpinner from "../BuyItNow/components/LoadingSpinner";
import NonMemberCartAPI from "../../shared/modules/NonMemberCartAPI";
import NonMemberCartHeader from "./NonMemberCartHeader";
import PropTypes from "prop-types";
import {withCookies} from "react-cookie";


const VerificationContainer = ({addressInfo, addresses, cookies, setAddressInfo, setBillingInfo, setIsEditingAddress, setVerificationStep}) => {
  const [selectedVerified, setSelectedVerified] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const isVerified = Boolean(addresses?.verifiedAddress);
  const getAddress = (address) => {
    let formattedAddress = "";
    if (address.street2) formattedAddress.concat(address.street2);
    formattedAddress += `${address.city}, ${address.state} ${address.zip}`;
    return formattedAddress;
  };

  const handleError = (response) => {
    setError(response.error);
    setDisplayErrors(true);
    setIsLoading(false);
  };

  const handleSuccess = (response) => {
    cookies.set("non_member_cart_contact", response.contact, {"path": "/"});
    setBillingInfo(prevState => ({
      ...prevState,
      "name": `${response.contact.first_name} ${response.contact.last_name}`
    }));
    setIsEditingAddress(false);
    setIsLoading(false);
  };
  const submitAddressInfo = (event) => {
    event.preventDefault();
    setIsLoading(true);
    const contactId = addressInfo.id;
    if (contactId) {
      NonMemberCartAPI.updateContact(contactId, addressInfo, handleSuccess, handleError);
    } else {
      NonMemberCartAPI.createContact(addressInfo, handleSuccess, handleError);
    }
  };

  const saveAddressInfo = (address) => {
    setAddressInfo(prevState => ({
      ...prevState,
      "city": address.city,
      "state": address.state,
      "street_address_1": address.street1,
      "street_address_2": address.street2,
      "zip": address.zip
    }));
  };

  const handleAddressSelection = (isVerifiedAddress) => {
    if (isVerifiedAddress) {
      setSelectedVerified(true);
      const {verifiedAddress} = addresses;
      saveAddressInfo(verifiedAddress);
    } else {
      setSelectedVerified(false);
      const {enteredAddress} = addresses;
      saveAddressInfo(enteredAddress);
    }
  };

  const handleUseEnteredSubmit = (event) => {
    saveAddressInfo(addresses.enteredAddress);
    submitAddressInfo(event);
  };

  const renderConfirmShipping = () => {
    const {enteredAddress, verifiedAddress} = addresses;
    return (
      <div className="verification-form">
        <NonMemberCartHeader
          classes="justify-between items-center text-lg"
          title="confirm your shipping address"
        />
        <div
          className={`address-box ${selectedVerified ? "" : "highlighted"}`}
          onClick={() => handleAddressSelection(false)}
        >
          <div className={`checkmark${selectedVerified ? "" : "-highlighted"}`}>
            {!selectedVerified && <div className="inner-circle" />}
          </div>
          <div className="address-section">
            <div className="ttcommons-demibold">
              What you entered
            </div>
            <div className="address-checkbox" />
            <div>
              {enteredAddress.street1}
            </div>
            <div>
              {getAddress(enteredAddress)}
            </div>
          </div>
        </div>
        <div
          className={`address-box ${selectedVerified ? "highlighted" : ""}`}
          onClick={() => handleAddressSelection(true)}
        >
          <div className={`checkmark${selectedVerified ? "-highlighted" : ""}`}>
            {selectedVerified && <div className="inner-circle" />}
          </div>
          <div className="address-section">
            <div className="ttcommons-demibold">
            Recommended
            </div>
            <div>
              {verifiedAddress.street1}
            </div>
            <div>
              {getAddress(verifiedAddress)}
            </div>
          </div>
        </div>
        <div
          className="button-selections"
        >
          <button
            className="button-outlined-white button"
            onClick={() => setVerificationStep(false)}
            type="button"
          >
            Back
          </button>
          <button
            className="btn btn-primary btn-small button"
            disabled={isLoading}
            onClick={submitAddressInfo}
            type="button"
          >
            {isLoading ? <LoadingSpinner size={26} /> : "Continue"}
          </button>
        </div>
      </div>
    );
  };

  const renderFailedVerification = () => {
    const {enteredAddress} = addresses;

    return (
      <div className="failed-verification-form">
        <div className="header">
          { "we couldn't verify your address"}
        </div>
        <div className="text-center pb-2.5">
          Review the verification issues
        </div>
        <div className="text-left ttcommons-demibold title">
            What you entered
        </div>
        <div className="address-box">
          <div className="address-section">
            <div>
              {enteredAddress.street1}
            </div>
            <div>
              {getAddress(enteredAddress)}
            </div>
          </div>
        </div>
        <div className="text-left ttcommons-demibold title">
            Verification issues
        </div>
        <div className="address-box not-found">
          <div className="not-found-sign" />
          <div className="address-section">
            <div className="ttcommons-demibold">
              Address not found
            </div>
            <div>
              {enteredAddress.street1}
            </div>
            <div>
              {getAddress(enteredAddress)}
            </div>
          </div>
        </div>
        <div
          className="button-selections"
        >
          <button
            className="button-outlined-white button"
            disabled={isLoading}
            onClick={handleUseEnteredSubmit}
            type="button"
          >
            {isLoading ? <LoadingSpinner
              color="black"
              size={26}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            /> : "Use Entered"}
          </button>
          <button
            className="btn btn-primary btn-small button"
            onClick={() => setVerificationStep(false)}
            type="button"
          >
            Make Changes
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="verification-container">
      {
        isVerified && renderConfirmShipping()
      }
      {
        !isVerified && renderFailedVerification()
      }
    </div>
  );

};

VerificationContainer.defaultProps = {
  "cookies": {},
  "verificationError": null
};
VerificationContainer.propTypes = {
  "addressInfo": PropTypes.object.isRequired,
  "addresses": PropTypes.object.isRequired,
  "cookies": PropTypes.object,
  "setAddressInfo": PropTypes.func.isRequired,
  "setBillingInfo": PropTypes.func.isRequired,
  "setIsEditingAddress": PropTypes.func.isRequired,
  "setVerificationStep": PropTypes.func.isRequired
};

export default withCookies(VerificationContainer);
